import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NovaDialogConfig } from '../../interfaces/nova-dialog-config.interface';

@Component({ standalone: false,
  selector: 'app-nova-dialog',
  templateUrl: './nova-dialog.component.html',
  styleUrls: ['./nova-dialog.component.scss']
})
export class NovaDialogComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: NovaDialogConfig) { }

  ngOnInit(): void {
  }

}

